// src/services/htmlUtils.ts

/**
 * Rimuove tutti gli attributi style dagli elementi HTML presenti nella stringa fornita.
 * @param htmlString La stringa HTML da processare.
 * @returns La stringa HTML senza attributi style.
 */
export function removeInlineStyles(htmlString: string): string {
  if (!htmlString) return htmlString;
  // Usa una DOMParser per manipolare il DOM in modo sicuro
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  // Seleziona tutti gli elementi con attributo style
  doc.querySelectorAll('[style]').forEach((el) => {
    el.removeAttribute('style');
  });
  return doc.body.innerHTML;
}
